module.exports = __webpack_public_path__ + "img/yidu.df8f9c2c.svg";